import moment from "moment";

export function sortByDate(date1: Date, date2: Date) {
    if (!date1 || !date2) return 0;
    const m1 = moment(date1);
    const m2 = moment(date2);

    if (m1.isSame(m2, 'day')) return 0;
    return m1.isAfter(m2, 'day') ? 1 : -1;
}